
import { createAction } from 'redux-actions'
import fetch from 'lib/fetch'

export const RESET_PASSWORD_REQUESTING = 'RESET_PASSWORD_REQUESTING'
export const RESET_PASSWORD_REQUEST_ERROR = 'RESET_PASSWORD_REQUEST_ERROR'
export const RESET_PASSWORD_REQUESTED = 'RESET_PASSWORD_REQUESTED'

export const resetPasswordRequesting = createAction(RESET_PASSWORD_REQUESTING)
export const resetPasswordRequestError = createAction(RESET_PASSWORD_REQUEST_ERROR)
export const resetPasswordRequested = createAction(RESET_PASSWORD_REQUESTED)

export const resetPassword = data => dispatch => {
  dispatch(resetPasswordRequesting())
  fetch('/api/password-resets', {
    body: JSON.stringify(data),
    method: 'PUT'
  }).then(res => {
    if (res.ok) {
      return res.json()
    }
    const error = new Error('Unable to reset password')
    error.status = res.status
    throw error
  })
  .then(user => {
    delete user.password // just in case
    dispatch(resetPasswordRequested({ user }))
    window.analytics.track('Reset Password', { user })
    window.location = `/login?email=${encodeURIComponent(user.email)}`
  })
  .catch(error => {
    dispatch(resetPasswordRequestError({ error }))
  })
}



// WEBPACK FOOTER //
// ./actions/reset.js